/**
 * Inline icons for the custom player chrome.
 *
 * Hand-rolled SVGs so we don't pull in an icon library for five glyphs. All
 * use `currentColor` so the parent button drives hue (default white, hover
 * brightens). 16x16 viewBox kept consistent across the set.
 */
import { FC } from "react";

interface IconProps {
  size?: number | string;
  className?: string;
}

const fillProps = (size: number | string, className?: string) => ({
  width: size,
  height: size,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  className,
});

const strokeProps = (size: number | string, className?: string) => ({
  width: size,
  height: size,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  className,
});

export const PlayChromeIcon: FC<IconProps> = ({ size = 16, className }) => (
  <svg {...fillProps(size, className)}>
    <path d="M4 2.5v11l9-5.5z" />
  </svg>
);

export const PauseChromeIcon: FC<IconProps> = ({ size = 16, className }) => (
  <svg {...fillProps(size, className)}>
    <rect x="3.5" y="2.5" width="3" height="11" rx="0.5" />
    <rect x="9.5" y="2.5" width="3" height="11" rx="0.5" />
  </svg>
);

export const MutedIcon: FC<IconProps> = ({ size = 16, className }) => (
  <svg {...fillProps(size, className)}>
    <path d="M2.5 6h2.5l3-2.5v9L5 10H2.5z" />
    <path
      d="M10.5 6.5l3 3M13.5 6.5l-3 3"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const VolumeIcon: FC<IconProps> = ({ size = 16, className }) => (
  <svg {...fillProps(size, className)}>
    <path d="M2.5 6h2.5l3-2.5v9L5 10H2.5z" />
    <path
      d="M10.5 5.5c1 .8 1 4.2 0 5M12.5 4c1.8 1.5 1.8 6.5 0 8"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const FullscreenChromeIcon: FC<IconProps> = ({
  size = 16,
  className,
}) => (
  <svg {...strokeProps(size, className)}>
    <path d="M2 5V2h3" />
    <path d="M14 5V2h-3" />
    <path d="M2 11v3h3" />
    <path d="M14 11v3h-3" />
  </svg>
);
